<template>
	<div>
		<v-content>
			<v-container fluid>        
              <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="productConfig == '' || runSave == true" /></center>   
              <v-flex xs3>
                <v-text-field v-if="productConfig != '' && runnSave == false && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                <v-text-field append-icon="search" v-if="productConfig != '' && runnSave == false && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>				
				<v-data-table :headers="headers" v-if="productConfig != '' && runSave == false" :search="search" :items="productConfig.products" class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
						<td width="32%" class="text-xs-right">{{ props.item.pli_code }} - {{ props.item.pli_description }}</td>      
						<td width="28%" class="text-xs-right"><v-select :items="productConfig.factories" label="Factory of Origin" v-model="props.item.factories" class="noBorder" multiple solo item-value="id"></v-select></td>  
                        <td width="28%" class="text-xs-right"><v-select :items="transportCalc" label="Transport Calculation" v-model="props.item.calc_mode" solo item-value="id"></v-select></td>
                        <td width="12%" class="text-xs-right"><v-switch v-model="props.item.normalize_qty"></v-switch></td>                      
					</template>
				</v-data-table>
			</v-container>
		</v-content>		
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';  

  export default {
	name: 'StatusList',	
    data () {
		return {	
			search: '',
			headers: [         
                { text: 'Product', value: 'pli_description', width: '32%' },
                { text: 'Factory of Origin', value: 'factories', width: '28%' },
                { text: 'Transport Calculation', value: 'calc_mode', width: '28%' },
                { text: 'Normalize Quantity', value: 'normalize_quantity', width: '12%' }                
            ],
            transportCalc: [
              { id: 1, text: 'Include Vehicle Minimum Cost' },
              { id: 2, text: 'Exclude Vehicle Minimum Cost' },
              { id: 3, text: 'Exclude from Transport Calculation' },
            ]
		}
	},	
	computed: {
		...mapGetters([
			'objAuthorize',
			'productConfig',
			'globalModalParams',
            'runSave'
		])
	},
	beforeMount() {
        this.$store.dispatch('fncPopulateProductConfig');		
	}
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>